/** Shared trackBy helpers for *ngFor — stable references, safe index fallback. */

export function trackByIndex(index: number): number {
    return index;
}

export function trackByIdentity<T>(index: number, item: T): T {
    return item;
}

export function trackById(index: number, item: { id?: number | string | null }): number | string {
    return item?.id ?? index;
}

export function trackByUserId(index: number, item: { userId?: number | string | null }): number | string {
    return item?.userId ?? index;
}

export function trackByProjectId(index: number, item: { projectId?: number | string | null }): number | string {
    return item?.projectId ?? index;
}

export function trackByTaskId(index: number, item: { taskId?: number | string | null }): number | string {
    return item?.taskId ?? index;
}

export function trackByProjectTaskId(index: number, item: { projectTaskId?: number | string | null }): number | string {
    return item?.projectTaskId ?? index;
}

export function trackByTenantId(index: number, item: { tenantId?: number | string | null }): number | string {
    return item?.tenantId ?? index;
}

export function trackByKey(index: number, item: { key?: number | string | null }): number | string {
    return item?.key ?? index;
}

export function trackByCode(index: number, item: { code?: number | string | null }): number | string {
    return item?.code ?? index;
}

export function trackByName(index: number, item: { name?: number | string | null }): number | string {
    return item?.name ?? index;
}

export function trackByValue(index: number, item: { value?: number | string | null }): number | string {
    return item?.value ?? index;
}

export const TRACK_BY_PROP_MAP: Record<string, string> = {
    id: 'trackById',
    userId: 'trackByUserId',
    projectId: 'trackByProjectId',
    taskId: 'trackByTaskId',
    projectTaskId: 'trackByProjectTaskId',
    tenantId: 'trackByTenantId',
    key: 'trackByKey',
    code: 'trackByCode',
    name: 'trackByName',
    value: 'trackByValue',
};

export const TRACK_BY_PROP_PRIORITY = [
    'id',
    'userId',
    'projectId',
    'taskId',
    'projectTaskId',
    'tenantId',
    'key',
    'code',
    'value',
    'name',
] as const;
